module.exports = __webpack_public_path__ + "static/media/twitter.7556e059.svg";